import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const getNewImagesList: any = createAsyncThunk<any>(
	'getNewImagesList',
	async (data: any, { rejectWithValue }) => {
		try {
			if (data.imageType == 'NEEDS') {
				let arr: any = { data: { list: [], count: 0 } };
				return arr;
			} else {
				const response = await httpService.get(
					'/productService/imageV2',
					{
						params: data
					}
				);
				return response.data;
			}
			// console.log(response.data);
		} catch (error: any) {
			// console.log(error?.response?.data)
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const deleteNewImageList: any = createAsyncThunk<any>(
	'deleteNewImageList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.delete(
				'/productService/imageV2',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getImagesMatch: any = createAsyncThunk<any>(
	'getImagesMatch',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/imageV2/imagesMatch',
				{
					params: data
				}
			);
			return response.data;
			// console.log(response.data);
		} catch (error: any) {
			// console.log(error?.response?.data)
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const imagesMatchApprove: any = createAsyncThunk<any>(
	'imagesMatchApprove',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/imageV2/imagesMatch',
				data
			);
			return response.data;
			// console.log(response.data);
		} catch (error: any) {
			// console.log(error?.response?.data)
			return rejectWithValue(error?.response?.data);
		}
	}
);
